import styled, { css } from 'styled-components';

import { type CardSizes } from '@pkg/components';
import { loadingSkeletonKeyframes } from '@pkg/motion';

interface CardInsiderProps {
    $cardSize?: CardSizes;
    $disableClick?: boolean;
    $height?: number;
    $isLoading?: boolean;
    $isNFT?: boolean;
    $isToken?: boolean;
    $isSelected?: boolean;
}

export const Wrapper = styled.div<{ $isHidden?: boolean }>`
    display: flex;
    width: 100%;
    ${({ $isHidden }) =>
        $isHidden &&
        css`
            opacity: 0.3;
            filter: grayscale(100%);
            &:hover {
                opacity: 1;
                filter: grayscale(0%);
            }
        `}
`;

export const CardInside = styled.div<CardInsiderProps>`
    display: flex;
    flex-direction: column;

    background: linear-gradient(206.7deg, #323232 0.77%, #404148 20.42%, #242424 73.73%);
    border-radius: 10px;

    width: 100%;

    position: relative;
    z-index: 0;

    transition:
        box-shadow 200ms ease,
        background 200ms ease;

    padding: 12px;
    gap: 12px;

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                padding: 6px;
                gap: 8px;
            `;
        }
    }}

    ${({ $disableClick }) =>
        $disableClick
            ? css`
                  pointer-events: none;
              `
            : css`
                  &:hover {
                      box-shadow:
                          0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
                          0 0 0 1px rgba(255, 255, 255, 0.1) inset;
                  }
              `}

    ${({ $height }) =>
        $height &&
        css`
            height: ${$height}px;
        `}

    ${({ $isNFT }) =>
        $isNFT &&
        css`
            background: rgba(189, 123, 255, 0.15);
        `}

    ${({ $isToken }) =>
        $isToken &&
        css`
            background: rgba(145, 209, 255, 0.15);
        `}

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            pointer-events: none;
            animation: ${loadingSkeletonKeyframes} 2s ease-in-out infinite;
            &:hover {
                opacity: 0.7;
            }
        `}

    ${({ $isSelected }) =>
        $isSelected &&
        css`
            background: #523df1;
        `}
`;

export const CardMediaHolder = styled.div`
    cursor: pointer;
    position: relative;
    z-index: 1;
`;

export const PricesPadding = styled.div`
    padding: 0 8px 8px;
`;
